module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/not_such_thing_3edc8b9be6dda9a3219143713a2463f2.jpg";